import React from 'react';
import { AuthorPage } from './pages/AuthorPage';
export function App() {
  return <AuthorPage data-id="element-0" />;
}